import { render } from "./FeaturesStackView.vue?vue&type=template&id=fdd4c2a0"
const script = {}

import "./FeaturesStackView.vue?vue&type=style&index=0&id=fdd4c2a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__